import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISlotList } from "../../../Pages/Slot/ISlot";

export const AddSlotSlicer = createSlice({
  name: "AddSlot",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISlotList>,
  reducers: {
    addSlot: (state, _) => {
      state.isLoading = true;
    },
    successAddSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddSlotState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSlot,
  failureAddSlot,
  successAddSlot,
  clearAddSlotState,
} = AddSlotSlicer.actions;

export default AddSlotSlicer.reducer;
